


































import Vue from "vue";
import { Header } from "@/components/MyTable.vue";
import { ListHeader } from "@/components/MyListCard.vue";
import { mapState, mapActions, mapGetters } from "vuex";

const RulesHeader: Header[] = [
  { title: "pod 名称", key: "", width: 240 },
  { title: "负载类型", key: "", width: 140 },
  { title: "容器名称", key: "", width: 140 },
  { title: "应用名称", key: "", width: 140 },
  { title: "访问模式", key: "", width: 180 },
  { title: "挂载路径", key: "", width: 140 }
];

const infoHeader: ListHeader[] = [
  { title: "存储卷名称", key: "name" },
  { title: "存储卷描述", key: "description" },
  { title: "容量（GiB）", key: "capacity" },
  { title: "访问模式", key: "model" },
  { title: "存储类型", key: "storageClassName" },
  { title: "挂载模式", key: "volumeMode" },
  { title: "挂载名称", key: "volumeName" },
  { title: "创建人", key: "createBy" },
  { title: "创建时间", key: "createTime" }
];
export default Vue.extend({
  name: "Overview",
  props: { data: { type: Object } },
  data() {
    return {
      RulesHeader,
      infoHeader,
      disabled: false
    };
  },
  computed: {
    ...mapState("PrjStorage/Container", [
      "pageNum",
      "total",
      "hasNext",
      "pageSize",
      "loading"
    ]),
    ...mapState("LoginInfo", ["project"]),
    ...mapGetters("PrjStorage/Container", ["tableData"])
  },
  methods: {
    ...mapActions("PrjStorage/Container", [
      "getData",
      "delete",
      "filterSearch",
      "pageTurn",
      "clear"
    ]),
    turnPage(page: number) {
      this.disabled = true;
      this.pageTurn({ page }).finally(() => {
        this.disabled = false;
      });
    }
  },
  watch: {
    "data.name": {
      immediate: true,
      handler(val) {
        if (val) {
          this.getData({
            url: `/storage/pvc/container/${this.project.id}/${val}`
          });
        }
      }
    }
  },
  // mounted() {},
  beforeDestroy() {
    this.clear();
  }
});
